import { Action, Dispatch } from 'redux'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import axios from 'axios'
import { ACCEPT_INVITATION_ENDPOINT } from 'constants/urls'
import { push } from 'connected-react-router'
import { setEmailErrorAction } from 'reducks/error/actions'

const acceptInvitation = (email: string, password: string, token: string) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(showLoadingAction())
    try {
      await axios.post(
        ACCEPT_INVITATION_ENDPOINT,
        { email, password, token },
        {
          headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
        }
      )
      dispatch(hideLoadingAction())
      dispatch(push('/register/complete?type=create'))
    } catch (e) {
      if (axios.isAxiosError(e)) {
        if (e.response?.data.status === 'warning') {
          dispatch(
            setEmailErrorAction(
              '対象のメールアドレスと一致しません。メールアドレスをお確かめの上、再入力してください。'
            )
          )
          dispatch(hideLoadingAction())
        } else {
          dispatch(setEmailErrorAction(e.response?.data.message))
          dispatch(hideLoadingAction())
        }
      } else {
        dispatch(setEmailErrorAction(''))
        dispatch(hideLoadingAction())
      }
    }
  }
}

export default acceptInvitation
